<script lang="ts" setup>
import type { ISearchState, SearchFilterOptionWithFilterName } from '@/components/Search/types.ts'
import { computed, ref } from 'vue'
import { useI18n } from '@/plugins/i18n'
import AllSelectedFiltersModal from './AllSelectedFiltersModal/index.ce.vue'
import SelectedFilters from './SelectedFilters/index.ce.vue'
import { useSearchStore } from '@/components/Search/store/index.ts'

const emit = defineEmits(['clearAll', 'removeFilter', 'saveFilters'])

//props
interface Props {
  filterKeys: (keyof ISearchState)[]   // restricts to valid state keys
}

const props = withDefaults(defineProps<Props>(), {
  filterKeys: () => [] as (keyof ISearchState)[]
})

//ref
const displayViewAllFiltersModal = ref(false);

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

//store
const searchStore = useSearchStore()


// combine filters into one flat array
const combinedFilters = computed(() => {
  return props.filterKeys.flatMap(key => {
    const value = searchStore[key]

    if (Array.isArray(value)) {
      return value.map(item => ({ ...item, filterName: key })) as SearchFilterOptionWithFilterName[]
    }

    if (typeof value === 'string' || value instanceof Date) {
      // wrap string in array or skip depending on what you need
      return [{ id: value, text: value, filterName: key }] as SearchFilterOptionWithFilterName[]
    }

    return [] // fallback for undefined or other types
  })
})


// limit to first 10
const limitedFilters = computed(() => combinedFilters.value.slice(0, 10))

// check if there are any selected filters
const hasSelectedFilters = computed(() => combinedFilters.value.length > 0)

// events
const handleViewAllFiltersDisplay = (value: boolean) => {
  displayViewAllFiltersModal.value = value
}

const saveFilters = (updatedFilters: Record<string, SearchFilterOptionWithFilterName[]>) => {
  handleViewAllFiltersDisplay(false);
  emit('saveFilters', updatedFilters);
}

// const removeFilter = (item: SearchFilterOption) => {
//   for (const key of props.filterKeys) {
//     if ((searchStore[key] as SearchFilterOption[])?.includes(item)) {
//       // @ts-ignore
//       searchStore.removeFilter(key, item)
//       break
//     }
//   }
// }
</script>

<template>
    <div v-show="hasSelectedFilters" class="search-result--selected-filters">
        <SelectedFilters v-if="limitedFilters.length" :selectedFilters="limitedFilters"  @removeFilter="(item)=>emit('removeFilter', item)">
          <template v-slot:afterFilters>
            <div class="btn-transparent" v-show="combinedFilters.length>10" @click="handleViewAllFiltersDisplay(true)">{{ t('viewAllFilters') }}</div>
            <!-- <div class="dummy-spacer" v-if="combinedFilters.length<=10" >&nbsp;</div> -->
            <div :class="['clear-all-wrapper', combinedFilters.length <= 10 ? 'right-aligned' : '']" >
                <div :class="['clear-all']" @click="() => emit('clearAll')">{{ t('clearAllFilters') }}</div>
            </div>
          </template>
        </SelectedFilters>       
        <AllSelectedFiltersModal v-show="combinedFilters.length>10" 
          :filterKeys="filterKeys" 
          :display="displayViewAllFiltersModal" 
          @closeModal="handleViewAllFiltersDisplay(false)"
          @saveFilters="saveFilters"></AllSelectedFiltersModal>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>